 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-048f1218":"4ac09ef0","chunk-0aa7f988":"c5781b12","chunk-0c470960":"3b019064","chunk-14ed8b58":"8c8a11e2","chunk-198d945a":"7807ad0d","chunk-283a76ca":"4f61617d","chunk-28dd490e":"eb2d9617","chunk-2d0aadaf":"79dee9c7","chunk-2d0bff13":"17117d74","chunk-2d0c04a1":"70a9b850","chunk-2d237915":"2b768c30","chunk-343afc12":"525fcbcc","chunk-3d7990ee":"2275b1ae","chunk-3f5ed260":"9905f4f5","chunk-40db29f6":"195e4119","chunk-41b023ad":"853a122e","chunk-4c48a1ab":"e1847625","chunk-4c62db05":"f885745f","chunk-51b60226":"3b658944","chunk-56b30132":"fc4df0a8","chunk-bf4985cc":"42e50e4d","chunk-59149f8e":"ef8c1c97","chunk-5b7731b4":"4142c7ca","chunk-5bb14700":"2f58da75","chunk-5f696760":"167603ab","chunk-6089ecdd":"d908ce11","chunk-6786120a":"0477f04d","chunk-6f1064fa":"6b25ceea","chunk-73c8666e":"f38f4106","chunk-097bace7":"6a8ad1e8","chunk-21f2af60":"b186499c","chunk-742a6fe3":"2d82e693","chunk-7603483a":"619762c0","chunk-77095fec":"13c3e05f","chunk-7f2036d2":"6203dfe3","chunk-7fae4090":"90bd40c9","chunk-84217e84":"8159fc12","chunk-954dbafa":"06d8c8fd","chunk-9c804bd4":"74693920","chunk-a0594ea8":"aaec2945","chunk-a69b736c":"a670a2d2","chunk-c68a6e52":"fc7bf8cd","chunk-e4a43830":"99363587","chunk-e9935308":"99873705","chunk-08747a2e":"018ed3a3","chunk-09adf984":"caef33d8","chunk-4e9a3c56":"a6b387e9","chunk-1e4ba232":"d94b17fe","chunk-a6a3c7bc":"1ce08a1e","chunk-0f0fcc16":"7d2bd7c8","chunk-5f3db7ff":"46767c75","chunk-63e818c1":"f23ecb8a","chunk-ed4a6488":"ad99e6e8","chunk-ddf3068a":"6d2d970b","chunk-ea08fd96":"20b7c287","chunk-f1f81e22":"4949ff71","chunk-f39665d2":"e5396119","chunk-f45bd996":"dbeb57c3","chunk-fdc281a0":"ff0d3507","chunk-fe091ed0":"9749fc8b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-048f1218":1,"chunk-0aa7f988":1,"chunk-0c470960":1,"chunk-14ed8b58":1,"chunk-198d945a":1,"chunk-283a76ca":1,"chunk-28dd490e":1,"chunk-343afc12":1,"chunk-3d7990ee":1,"chunk-3f5ed260":1,"chunk-40db29f6":1,"chunk-41b023ad":1,"chunk-4c48a1ab":1,"chunk-4c62db05":1,"chunk-51b60226":1,"chunk-56b30132":1,"chunk-bf4985cc":1,"chunk-59149f8e":1,"chunk-5b7731b4":1,"chunk-5bb14700":1,"chunk-5f696760":1,"chunk-6089ecdd":1,"chunk-6786120a":1,"chunk-6f1064fa":1,"chunk-73c8666e":1,"chunk-097bace7":1,"chunk-21f2af60":1,"chunk-742a6fe3":1,"chunk-7603483a":1,"chunk-77095fec":1,"chunk-7f2036d2":1,"chunk-7fae4090":1,"chunk-84217e84":1,"chunk-954dbafa":1,"chunk-9c804bd4":1,"chunk-a0594ea8":1,"chunk-a69b736c":1,"chunk-c68a6e52":1,"chunk-e4a43830":1,"chunk-e9935308":1,"chunk-08747a2e":1,"chunk-09adf984":1,"chunk-4e9a3c56":1,"chunk-1e4ba232":1,"chunk-a6a3c7bc":1,"chunk-0f0fcc16":1,"chunk-5f3db7ff":1,"chunk-63e818c1":1,"chunk-ed4a6488":1,"chunk-ddf3068a":1,"chunk-ea08fd96":1,"chunk-f1f81e22":1,"chunk-f39665d2":1,"chunk-f45bd996":1,"chunk-fdc281a0":1,"chunk-fe091ed0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-048f1218":"b1ef772c","chunk-0aa7f988":"5f02922f","chunk-0c470960":"0f0971a8","chunk-14ed8b58":"be7a9c80","chunk-198d945a":"b6922f81","chunk-283a76ca":"d1fcb1f2","chunk-28dd490e":"fb55a6bf","chunk-2d0aadaf":"31d6cfe0","chunk-2d0bff13":"31d6cfe0","chunk-2d0c04a1":"31d6cfe0","chunk-2d237915":"31d6cfe0","chunk-343afc12":"beb68d9e","chunk-3d7990ee":"e545471a","chunk-3f5ed260":"d2353036","chunk-40db29f6":"d38e9218","chunk-41b023ad":"4fdf9bb2","chunk-4c48a1ab":"7750dfd6","chunk-4c62db05":"51935913","chunk-51b60226":"4819356e","chunk-56b30132":"16c4a45f","chunk-bf4985cc":"b50d52d2","chunk-59149f8e":"41f11a31","chunk-5b7731b4":"e6b32ce7","chunk-5bb14700":"a6d8db44","chunk-5f696760":"a4bf6a4a","chunk-6089ecdd":"6338791f","chunk-6786120a":"850d1706","chunk-6f1064fa":"acb51a8b","chunk-73c8666e":"0f207203","chunk-097bace7":"bfb9312e","chunk-21f2af60":"401d6ed7","chunk-742a6fe3":"e24fadf1","chunk-7603483a":"959020e1","chunk-77095fec":"fec46cc8","chunk-7f2036d2":"fed01756","chunk-7fae4090":"20362c3a","chunk-84217e84":"a72ce82c","chunk-954dbafa":"db8ccf3e","chunk-9c804bd4":"0f6efb4f","chunk-a0594ea8":"08b2ceb9","chunk-a69b736c":"be560d0d","chunk-c68a6e52":"1e867ae9","chunk-e4a43830":"9021f1a5","chunk-e9935308":"ea51c598","chunk-08747a2e":"133b04bf","chunk-09adf984":"0b7ea9a6","chunk-4e9a3c56":"cff46542","chunk-1e4ba232":"4040121a","chunk-a6a3c7bc":"6bf6e6db","chunk-0f0fcc16":"4bd13a57","chunk-5f3db7ff":"0bb1e7c5","chunk-63e818c1":"4c6ecc55","chunk-ed4a6488":"b961fc05","chunk-ddf3068a":"072c325c","chunk-ea08fd96":"cac57fa7","chunk-f1f81e22":"1cbe6a78","chunk-f39665d2":"751a2553","chunk-f45bd996":"87b882cd","chunk-fdc281a0":"0b814ed7","chunk-fe091ed0":"d418f32c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://dstatic.wwjrxx.com/live/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
